import classNames from 'classnames';
import * as React from 'react';
import css from './BaseLayout.module.scss';
import MerchantGlobalFooter from './MerchantGlobalFooter';

export interface Props extends React.HTMLProps<{}> {
  isCoubicApp: boolean;
}

const BaseLayoutMerchantOnlyFooter = (props: Props) => {
  return (
    <div className={classNames(css.BaseLayout, props.className)}>
      {props.children}
      {!props.isCoubicApp && (
        <div className={css.BaseLayout__Footer}>
          <MerchantGlobalFooter />
        </div>
      )}
    </div>
  );
};

export default BaseLayoutMerchantOnlyFooter;
